// `ctaClicked` uses an override so the event name reads "CTA Clicked"
// rather than the auto-generated "Cta Clicked".
export default [
  'viewed',
  ['ctaClicked', 'Projects Upsell Modal : CTA Clicked'],
  'dismissed'
]
